module.exports = __webpack_public_path__ + "media/images/icon-filter-website-ce7a129af0ad0fc26b6fa9a1ad40ee8c.png";